import { vModelDynamic as _vModelDynamic, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63d7d5a6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("input", {
    class: ["zpt-input-time", { 'ztp-input-error': !_ctx.isCorrectValue }],
    placeholder: _ctx.labelPlaceholder,
    type: _ctx.onlyMinuteSeconds ? 'text' : 'time',
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.insideValue = $event))
  }, null, 10, ["placeholder", "type"])), [
    [_vModelDynamic, _ctx.insideValue]
  ])
})